<template>
  <div>
    <!-- <v-card color="grey lighten-4" flat> -->
      <!-- <v-card-text> -->
        <!-- <v-container fluid> -->
          <!-- <v-layout row wrap> -->
            <!-- <v-flex xs12 sm6>
              <v-subheader v-text="'Slots'"></v-subheader>
            </v-flex> -->
            <!-- <v-flex xs12 sm12> -->
              <v-select
                label="Profissional"
                v-bind:items="people"
                v-model="e11"
                item-text="name"
                item-value="name"
                multiple
                chips
                max-height="auto"
                autocomplete
              >
                <template slot="selection" slot-scope="data">
                  <v-chip
                    close
                    @input="data.parent.selectItem(data.item)"
                    :selected="data.selected"
                    class="chip--select-multi"
                    :key="JSON.stringify(data.item)"
                  >
                    <v-avatar>
                      <img :src="data.item.avatar">
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-avatar>
                      <img v-bind:src="data.item.avatar"/>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            <!-- </v-flex> -->
          <!-- </v-layout> -->
        <!-- </v-container> -->
      <!-- </v-card-text> -->
    <!-- </v-card> -->
    <!-- {{e11}} -->
  </div>  
</template>

<script>
  const srcs = {
    1: 'https://app.kazah.com.br/img/newuser.png',
    2: 'https://app.kazah.com.br/img/newuser.png',
    3: 'https://app.kazah.com.br/img/newuser.png',
    4: 'https://app.kazah.com.br/img/newuser.png',
    5: 'https://app.kazah.com.br/img/newuser.png'
  }
  export default {
    name: 'Professionals',
    data () {
      return {
        e11: [],
        people: [
          { header: 'Otorrino' },
          { name: 'Sandra Adams', group: 'Otorrino', avatar: srcs[1] },
          { name: 'Ali Connors', group: 'Otorrino', avatar: srcs[2] },
          { name: 'Trevor Hansen', group: 'Otorrino', avatar: srcs[3] },
          { name: 'Tucker Smith', group: 'Otorrino', avatar: srcs[2] },
          { divider: true },
          { header: 'Cardiologista' },
          { name: 'Britta Holt', group: 'Cardiologista', avatar: srcs[4] },
          { name: 'Jane Smith ', group: 'Cardiologista', avatar: srcs[5] },
          { name: 'John Smith', group: 'Cardiologista', avatar: srcs[1] },
          { name: 'Sandra Williams', group: 'Cardiologista', avatar: srcs[3] },
          { divider: true },
          { header: 'Oftalmo' },
          { name: 'Britta Holt1', group: 'Oftalmo', avatar: srcs[4] },
          { name: 'Jane Smith1 ', group: 'Oftalmo', avatar: srcs[5] },
          { name: 'John Smith1', group: 'Oftalmo', avatar: srcs[1] },
          { name: 'Sandra Williams1', group: 'Oftalmo', avatar: srcs[3] }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Professionals.vue